<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container">
  <div cdkDragHandle class="flex justify-between items-baseline pr-4">
    <h2 mat-dialog-title> External Scope of Appointment </h2>
    <button type="button" mat-icon-button class="leading-none" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    <form [formGroup]="externalForm" autocomplete="off">
      <div class="flex gap-4">
        <mat-form-field class="grow">
          <mat-label>Appointment Date</mat-label>
          <input formControlName="appointmentDate" matInput [matDatepicker]="appDatePicker" appDate (mousedown)="$event.stopPropagation()">
          <mat-datepicker-toggle matSuffix [for]="appDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #appDatePicker></mat-datepicker>
          @if (externalForm.invalid) {
            <mat-error>Please enter a valid date as "MM/DD/YYYY"</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="grow">
          <mat-label>Client Signed Date</mat-label>
          <input formControlName="clientSignedDate" matInput [matDatepicker]="clientDatePicker" appDate (mousedown)="$event.stopPropagation()">
          <mat-datepicker-toggle matSuffix [for]="clientDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #clientDatePicker></mat-datepicker>
          @if (externalForm.invalid) {
            <mat-error>Please enter a valid date as "MM/DD/YYYY"</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="flex">
        <mat-form-field class="w-[50%]">
          <mat-label>Source</mat-label>
          <mat-select disableOptionCentering formControlName="externalSource">
            @for (source of soaSources; track source) {
              <mat-option [value]="source.soa_source_id" [label]="source.soa_source_name">{{source.soa_source_name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </form>

  </div>
  <div mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>Cancel</button>
    @if (externalForm.valid) {
      <button mat-flat-button color="primary" [disabled]="isButtonClick" (click)="saveExternalSOA()">Save External SOA</button>
    }
  </div>
</div>